'use client'

import Lottie from 'react-lottie-player'

import waveAnimation from '../_assets/hero-whitewave.json'

/**
 * 히어로 차량 이미지 영역의 wave 그래픽 — 차 사진 하단(휠 아래)에 깔리는 wave 모션.
 * 디자이너 제공 Lottie(mycle.co.kr/resources/images/contents/img-whitewave.json)를 번들로 사용.
 * 크기·위치는 호출부(CarImage)에서 className으로 제어한다.
 */
interface IPlatformGraphicProps {
  className?: string
}

const PlatformGraphic = ({ className }: IPlatformGraphicProps) => (
  <div aria-hidden className={className}>
    <Lottie loop play animationData={waveAnimation} className='h-full w-full' />
  </div>
)

export default PlatformGraphic
